import { Waveform } from '@mi-front/core';
import { memo } from 'react';
import NoAudio from './message/NoAudio';
import { WaveformPath } from './WaveformPath';

interface Props {
  readonly waveform: Waveform;
  readonly width: number;
  readonly height: number;
  readonly startTs: number;
  readonly x: number;
  readonly fgColor: string;
  readonly compressed?: boolean;
}

export const WaveformRenderer = memo(function WaveformRenderer(p: Props) {
  const { waveform, width, height, startTs, x, fgColor, compressed } = p;

  const blankPercent = waveform.data.filter((d) => d === 0).length / waveform.data.length;

  if (blankPercent >= 0.5) {
    return <NoAudio noText={compressed} parentWidth={width} parentHeight={height} />;
  }

  return (
    <g transform={`translate(-0.5,${height / 2})`}>
      <WaveformPath
        ts={startTs}
        waveform={waveform}
        x={x}
        width={width}
        height={height}
        fill={fgColor}
      />
    </g>
  );
});
